export const blockIconsSearchBlender = (
	<span className='material-symbols-outlined'>blender</span>
);
